import Page403 from "@/pages/403";
import InfoPage from "@/pages/info";
import RoleGuard from "@/pages/role-guard";
import { Permissions } from "@/utils/permissions";
import { getEnv } from "@/utils/runtime-config";
import { lazy } from "react";
import { makeHandle } from "./router.helpers";

const Calendar = lazy(() => import("@/pages/calendar"));

const LegalPage = lazy(() => import("@/pages/legal"));

/**
 * Routes with no loader and no dynamic segments: placeholders, informational
 * pages and the unauthorized screen.
 */
export const createStaticRoutes = () => {
  // Fails closed: envsubst leaves an unset SHOW_INFO_PAGE blank in the runtime
  // config and getEnv() treats a blank value as missing, so the fallback has to
  // be the safe one or an unconfigured deploy would expose this debug route.
  const shouldShowInfoPage = getEnv("SHOW_INFO_PAGE", "false") === "true";

  return [
    {
      path: "aplicaciones",
      Component: () => <div>Aplicaciones</div>,
      handle: makeHandle({ label: "Aplicaciones" }),
    },
    {
      path: "calendario",
      children: [
        {
          index: true,
          element: (
            <RoleGuard permissions={[Permissions.calendar.read]}>
              <Calendar />
            </RoleGuard>
          ),
          handle: makeHandle({ label: "Calendario" }),
        },
      ],
    },
    {
      path: "finanzas",
      Component: () => <div className="text-body">Finanzas</div>,
      handle: makeHandle({ label: "Finanzas" }),
    },
    {
      path: "reguladores",
      Component: () => <div className="text-body">Reguladores</div>,
      handle: makeHandle({ label: "Reguladores" }),
    },
    {
      path: "legal-info",
      element: (
        <RoleGuard permissions={[Permissions["privacy-policies"].view]}>
          <LegalPage />
        </RoleGuard>
      ),
      handle: makeHandle({ label: "Información Legal" }),
    },
    {
      path: "/403",
      element: <Page403 />,
      handle: makeHandle({ label: "Acceso no autorizado" }),
    },
    ...(shouldShowInfoPage
      ? [
          {
            path: "-/info",
            Component: () => <InfoPage />,
            handle: makeHandle({ label: "Info" }),
          },
        ]
      : []),
  ];
};
